// Mock Data - Paulare Empilhadeiras
// Cores da marca: Teal (#2DD4BF), Cinza escuro (#374151), Branco, Preto
// ATUALIZADO: Imagens oficiais dos sites das marcas

export const companyInfo = {
  name: "Paulare Empilhadeiras",
  slogan: "Elevando o seu Futuro",
  foundedYear: 2000,
  experience: "25 anos elevando o seu futuro",
  experienceYears: 25,
  phone: "(19) 3439-1326",
  whatsapp: "19981813077",
  whatsappFormatted: "(19) 98181-3077",
  email: "atendimento@paulare.com.br",
  emailContact: "contato@paulare.com.br",
  logo: "https://customer-assets.emergentagent.com/job_116c4487-fbc2-4d24-8bfa-fc864a8bb415/artifacts/ptp55v7g_logo%20%C2%B4paulare.png",
  logo25anos: "https://customer-assets.emergentagent.com/job_116c4487-fbc2-4d24-8bfa-fc864a8bb415/artifacts/lwrxkcfc_logo%20mais%2025%20anos.png",
  address: {
    street: "Rua José Piveta, 1033",
    neighborhood: "Jd. Nova Colina",
    city: "Saltinho",
    state: "SP",
    cep: "13.440-000"
  },
  social: {
    instagram: "https://www.instagram.com/paulareempilhadeiras/",
    facebook: "https://www.facebook.com/paulareempilhadeiras",
    linkedin: "https://www.linkedin.com/company/paulare-empilhadeiras/posts/?feedView=all"
  }
};

// Statistics for the hero section
export const heroStats = {
  years: "25+",
  yearsLabel: "anos de experiência",
  clients: "10000+",
  clientsLabel: "clientes satisfeitos",
  capacity: "35t",
  capacityLabel: "Capacidade Disponível"
};

export const aboutContent = {
  shortDescription: "A Paulare Empilhadeiras é uma empresa de vendas, locação e manutenção de equipamentos destinados à movimentação de cargas. Trabalha com produtos de alta qualidade, sendo importadora e trazendo modernidade ao Brasil.",
  fullDescription: "Criada em 2000, a Paulare Empilhadeiras tem como principal objetivo facilitar o transporte logístico em empresas de todos os portes. Rapidez e eficiência são nossas principais qualidades. Contamos com uma frota de empilhadeiras GLP, Diesel e Elétrica com capacidade entre 1 e 35 toneladas, além de acessórios como Clamp para Bobina, Deslocador Lateral e outros.",
  milestone: "Em 2007, importamos nossa primeira empilhadeira zero km, iniciando o trabalho de importação direta da fábrica para venda e locação.",
  mission: "Fornecer soluções de movimentação de materiais adequadas às necessidades dos clientes, com o compromisso de atingir excelentes resultados.",
  vision: "Ser referência regional no ramo de empilhadeiras, reconhecida pelos bons serviços prestados, satisfazendo clientes e equilibrando lucro e compromisso social.",
  values: ["Ética", "Qualidade", "Foco no Cliente", "Agilidade", "Responsabilidade", "Comprometimento", "Espírito de Equipe", "Autenticidade"]
};

export const services = [
  {
    id: 1,
    title: "Venda",
    description: "Empilhadeiras novas e usadas de diversas marcas e modelos, além de acessórios.",
    icon: "ShoppingCart"
  },
  {
    id: 2,
    title: "Locação",
    description: "Aluguel de empilhadeiras para otimização logística com contratos flexíveis.",
    icon: "Key"
  },
  {
    id: 3,
    title: "Compra",
    description: "Compramos empilhadeiras novas e usadas de todas as marcas e modelos.",
    icon: "HandCoins"
  },
  {
    id: 4,
    title: "Terceirização",
    description: "Terceirização do setor logístico com operadores treinados e qualificados.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Reforma",
    description: "Reforma e restauração completa de empilhadeiras com serviço de manutenção.",
    icon: "Wrench"
  },
  {
    id: 6,
    title: "Manutenção",
    description: "Manutenção preventiva e corretiva para sua frota de empilhadeiras.",
    icon: "Settings"
  }
];

export const brands = [
  { id: 1, name: "MAXIMAL", logo: null },
  { id: 2, name: "HANGCHA", logo: null },
  { id: 3, name: "PALETRANS", logo: null }
];

// Fuel type filters for the products page
export const fuelTypes = [
  { id: "diesel", name: "Diesel" },
  { id: "glp", name: "GLP" },
  { id: "eletrica", name: "Elétrica" }
];

// ===== HANGCHA PRODUCTS - Imagens oficiais de pt.hangchabrasil.com =====
export const hangchaProducts = [
  // =====================================================
  // ===== EQUIPAMENTOS À COMBUSTÃO (DIESEL/GLP) =====
  // =====================================================
  {
    id: 101,
    name: "X Series Diesel/GLP 1.0-3.5t",
    model: "CPCD/CPQD10-35X",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "HANGCHA",
    capacity: "1.0 a 3.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/49caf12a51bb96cf0f5f445fbbf93580.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/49caf12a51bb96cf0f5f445fbbf93580.jpg",
    features: [
      "Mastro wide-view com ampla visibilidade",
      "Display LCD com informações completas",
      "Motor diesel/GLP de alta eficiência",
      "Sistema hidráulico avançado",
      "Cabine ergonômica",
      "Baixo consumo de combustível"
    ],
    specifications: {
      "Capacidade de Carga": "1.000 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 7.000 mm",
      "Motor": "Diesel ou GLP",
      "Velocidade": "18-20 km/h",
      "Transmissão": "Powershift"
    },
    description: "Empilhadeira X Series HANGCHA a combustão interna, disponível em diesel ou GLP. Design robusto com ampla visibilidade e alta eficiência operacional."
  },
  {
    id: 102,
    name: "X Series Diesel/GLP 4.0-5.5t",
    model: "CPCD/CPQD40-55X",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "HANGCHA",
    capacity: "4.0 a 5.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/49caf12a51bb96cf0f5f445fbbf93580.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/49caf12a51bb96cf0f5f445fbbf93580.jpg",
    features: [
      "Alta capacidade de carga",
      "Motor turbo diesel potente",
      "Estrutura reforçada",
      "Display LCD multifuncional",
      "Sistema de freios a disco",
      "Cabine espaçosa e confortável"
    ],
    specifications: {
      "Capacidade de Carga": "4.000 - 5.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 7.000 mm",
      "Motor": "Diesel Turbo",
      "Potência": "55-65 kW",
      "Transmissão": "Powershift"
    },
    description: "Empilhadeira X Series HANGCHA para cargas médias-pesadas. Robusta e eficiente para operações industriais exigentes."
  },
  {
    id: 103,
    name: "X Series Diesel para Container 5-10t",
    model: "CPCD50-100X",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "HANGCHA",
    capacity: "5.0 a 10.0 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/b9081e36a03dc982f63e5f5a65780d02.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/5ebc1fe764c713b20d152ce0cf737842.jpg",
    features: [
      "Trabalha dentro de containers",
      "Motor Bosch-Yuchai common-rail de alta pressão",
      "Sistema de vídeo dianteiro e traseiro (8.5-10t)",
      "Display LCD com código de falhas",
      "Caixa elétrica integrada de nova geração",
      "Redução de 10% no consumo de combustível"
    ],
    specifications: {
      "Capacidade de Carga": "5.000 - 10.000 kg",
      "Centro de Carga": "600 mm",
      "Altura de Elevação": "até 3.600 mm",
      "Motor": "Diesel Bosch-Yuchai",
      "Garantia": "2 anos ou 4000 horas",
      "Característica": "Opera dentro de containers"
    },
    description: "Empilhadeira diesel HANGCHA X Series para operações em containers. Design de baixa altura e corpo estreito, ideal para ambientes confinados. Garantia estendida de 2 anos."
  },
  {
    id: 104,
    name: "X Series Diesel 5.5t",
    model: "CPCD55X",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "HANGCHA",
    capacity: "5.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/37b89bfeb7441793b343de62a58fc479.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/37b89bfeb7441793b343de62a58fc479.jpg",
    features: [
      "Capacidade de 5.5 toneladas",
      "Motor diesel industrial",
      "Alta estabilidade",
      "Cabine panorâmica",
      "Sistema hidráulico de alta performance",
      "Manutenção facilitada"
    ],
    specifications: {
      "Capacidade de Carga": "5.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.000 mm",
      "Motor": "Diesel Industrial",
      "Potência": "65 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel HANGCHA X Series 5.5t para operações de média-alta capacidade."
  },
  {
    id: 105,
    name: "X Series Diesel 8-12t",
    model: "CPCD80-120X",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "HANGCHA",
    capacity: "8.0 a 12.0 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/e408e997952ae232bda7df507e8d20f8.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/e408e997952ae232bda7df507e8d20f8.jpg",
    features: [
      "Alta capacidade de carga",
      "Motor diesel industrial robusto",
      "Sistema de vídeo integrado",
      "Cabine climatizada opcional",
      "Freios a disco",
      "Estrutura super reforçada"
    ],
    specifications: {
      "Capacidade de Carga": "8.000 - 12.000 kg",
      "Centro de Carga": "600 mm",
      "Altura de Elevação": "até 4.500 mm",
      "Motor": "Diesel Industrial",
      "Potência": "90-120 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel HANGCHA X Series para cargas pesadas de 8 a 12 toneladas. Ideal para portos e indústrias pesadas."
  },
  {
    id: 106,
    name: "Rough Terrain Diesel 4WD 1.5-1.8t",
    model: "CPCD15-18-RT",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "HANGCHA",
    capacity: "1.5 a 1.8 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/35271f7df1d5176aceb48c9cef8b53ee.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/51edb2fbb972adb2b57893597aa543ad.jpg",
    features: [
      "Tração 4x4 integral (2WD/4WD)",
      "Chassi elevado 280mm do solo",
      "Display LCD multifuncional",
      "Filtro de ar duplo",
      "Radiador de alta capacidade",
      "Transmissão hidráulica full-floating"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 1.800 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.000 mm",
      "Motor": "Diesel",
      "Tração": "2WD/4WD",
      "Distância ao Solo": "280 mm"
    },
    description: "Empilhadeira fora de estrada HANGCHA 4WD - compacta e resistente para terrenos difíceis. O conceito multipropósito permite trabalhar em diversas áreas com excelente performance."
  },
  {
    id: 107,
    name: "X Series GLP 1.5-3.8t",
    model: "CPQD15-38X",
    category: "empilhadeiras",
    fuelType: "glp",
    brand: "HANGCHA",
    capacity: "1.5 a 3.8 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/49caf12a51bb96cf0f5f445fbbf93580.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/49caf12a51bb96cf0f5f445fbbf93580.jpg",
    features: [
      "Motor GLP econômico",
      "Menor emissão de poluentes",
      "Ideal para ambientes internos e externos",
      "Display LCD avançado",
      "Sistema hidráulico eficiente",
      "Velocidade 18-20 km/h"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 3.800 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 - 7.000 mm",
      "Motor": "GLP",
      "Potência": "34-45 kW",
      "Torque": "140-208 N·m"
    },
    description: "Empilhadeira GLP HANGCHA X Series, versátil para uso interno e externo com baixa emissão de poluentes."
  },
  // =====================================================
  // ===== BATERIA DE LÍTIO - EMPILHADEIRAS VERDES =====
  // ===== 9 Modelos VERDES da página pt.hangchabrasil.com/product/list/Bateria_de_Lítio =====
  // ===== APENAS empilhadeiras de cor VERDE (não amarelas/laranjas) =====
  // =====================================================
  {
    id: 108,
    name: "XC Series Li-Ion 1.5-3.5t",
    model: "CPD15-35-XC",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "1.5 a 3.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/052a41fab07531880d51cc12218f5efb.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/052a41fab07531880d51cc12218f5efb.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/XC_series_electric_forklift_with_Li-Ion_power_1.5~3.5t",
    features: [
      "Motor AC de ultra-alta potência",
      "Sensores de velocidade e temperatura integrados",
      "Centro de gravidade baixo para estabilidade",
      "Sistema OPS opcional para segurança",
      "Componentes internos protegidos contra poeira e água",
      "Certificação CE"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 7.000 mm",
      "Motor": "AC Ultra-Alta Potência",
      "Bateria": "Li-Ion",
      "Certificação": "CE"
    },
    description: "Empilhadeira elétrica verde HANGCHA XC Series com bateria de lítio dedicada. Novo chassi com design compacto e eficiente."
  },
  {
    id: 109,
    name: "XC Series Li-Ion 2.0-3.5t (Light Duty)",
    model: "CPD20-35-XC-LD",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "2.0 a 3.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/efc3c6e3def1d8c6c4e98ce3b17bfe35.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/efc3c6e3def1d8c6c4e98ce3b17bfe35.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/XC_series_electric_forklift_with_Li-Ion_power_2.0~3.5t_(Light_Duty)",
    features: [
      "Versão Light Duty para operações leves",
      "Bateria de lítio ferro-fosfato (LiFePO4)",
      "Garantia de 5 anos ou 10.000 horas na bateria",
      "Carregamento rápido em menos de 2 horas",
      "Resistência IPX4 para uso externo",
      "Design sem manutenção com BMS integrado"
    ],
    specifications: {
      "Capacidade de Carga": "2.000 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 7.000 mm",
      "Motor": "AC de Alta Eficiência",
      "Bateria": "Li-Ion LiFePO4",
      "Proteção": "IPX4"
    },
    description: "Empilhadeira elétrica verde HANGCHA XC Series Light Duty - versão otimizada para operações de menor intensidade com alta eficiência."
  },
  {
    id: 110,
    name: "XC Series Li-Ion 4.0-5.0t",
    model: "CPD40-50-XC",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "4.0 a 5.0 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/c99ed5a3b0a37150eac62a32fda267b8.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/c99ed5a3b0a37150eac62a32fda267b8.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/XC_series_electric_forklift_with_Li-Ion_power_4.0~5.0t",
    features: [
      "Motor AC de ultra-alta potência",
      "Alta capacidade de carga",
      "Função de bloqueio de descida opcional",
      "Motor à prova de água e poeira",
      "Interruptor de corte de emergência padrão EU",
      "Centro de gravidade baixo para estabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "4.000 - 5.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 7.000 mm",
      "Motor": "AC Ultra-High Power",
      "Bateria": "Li-Ion",
      "Proteção": "Alta proteção IP"
    },
    description: "Empilhadeira elétrica verde HANGCHA XC Series 4-5t - Maior capacidade de carga, maior tempo de trabalho e maior eficiência."
  },
  {
    id: 111,
    name: "A Series Li-Ion 1.0-3.5t",
    model: "CPD10-35-A",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "1.0 a 3.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/fd39006b6d15d89e6cc202ca885a31a4.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/fd39006b6d15d89e6cc202ca885a31a4.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/A_series_1.0-3.5t_(Li-Ion)",
    features: [
      "Série A com bateria de lítio",
      "Design compacto e versátil",
      "Altura de elevação até 6.500mm",
      "Zero emissões",
      "Operação silenciosa",
      "Baixo custo de manutenção"
    ],
    specifications: {
      "Capacidade de Carga": "1.000 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.500 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Li-Ion",
      "Emissões": "Zero"
    },
    description: "Empilhadeira elétrica verde HANGCHA A Series com bateria de lítio - design versátil para diversas aplicações."
  },
  {
    id: 112,
    name: "A Series Dual Drive Li-Ion 2.0-3.5t",
    model: "CPD20-35-A-DD",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "2.0 a 3.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/19e209727ef09854fefc64fd3a9f2dc0.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/19e209727ef09854fefc64fd3a9f2dc0.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/A_series_Dual_Drive_Electric_Forklift(Li-Ion)",
    features: [
      "Sistema Dual Drive (tração dupla)",
      "Bateria de lítio de alta capacidade",
      "Altura de elevação até 6.500mm",
      "Maior tração e estabilidade",
      "Zero emissões",
      "Alta performance em rampas"
    ],
    specifications: {
      "Capacidade de Carga": "2.000 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.500 mm",
      "Motor": "Dual Drive AC",
      "Bateria": "Li-Ion",
      "Tração": "Dupla"
    },
    description: "Empilhadeira elétrica verde HANGCHA A Series Dual Drive - sistema de tração dupla para maior performance e estabilidade."
  },
  {
    id: 119,
    name: "A Series Li-Ion 4.0-4.99t",
    model: "CPD40-499-A",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "4.0 a 4.99 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/052a41fab07531880d51cc12218f5efb.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/052a41fab07531880d51cc12218f5efb.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/A_series_4.0-4.99t_(Li-Ion)",
    features: [
      "Alta capacidade de carga",
      "Bateria de lítio de grande porte",
      "Altura de elevação até 6.000mm",
      "Estrutura reforçada",
      "Zero emissões",
      "Ideal para operações industriais"
    ],
    specifications: {
      "Capacidade de Carga": "4.000 - 4.990 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.000 mm",
      "Motor": "Elétrico AC de Alta Potência",
      "Bateria": "Li-Ion",
      "Aplicação": "Industrial"
    },
    description: "Empilhadeira elétrica verde HANGCHA A Series 4-5t - alta capacidade com tecnologia de bateria de lítio."
  },
  {
    id: 120,
    name: "AE Series Li-Ion 1.5-3.5t",
    model: "CPD15-35-AE",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "1.5 a 3.5 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/efc3c6e3def1d8c6c4e98ce3b17bfe35.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/efc3c6e3def1d8c6c4e98ce3b17bfe35.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/AE_series_1.5-3.5t_(Li-Ion)",
    features: [
      "Série AE com tecnologia avançada",
      "Bateria de lítio de alta eficiência",
      "Altura de elevação até 7.000mm",
      "Design ergonômico",
      "Zero emissões",
      "Carregamento rápido"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 7.000 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Li-Ion",
      "Eficiência": "Alta"
    },
    description: "Empilhadeira elétrica verde HANGCHA AE Series - tecnologia avançada com bateria de lítio para operações eficientes."
  },
  {
    id: 121,
    name: "XC Series 3-Wheel Li-Ion 1.3-2.0t",
    model: "CPD13-20-XC-3W",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "1.3 a 2.0 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/c99ed5a3b0a37150eac62a32fda267b8.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/c99ed5a3b0a37150eac62a32fda267b8.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/XC_Series_3-Wheel_Electric_Forklift_Truck_With_Lithium_Power",
    features: [
      "Design de 3 rodas compacto",
      "Raio de giro mínimo",
      "Bateria de lítio",
      "Ideal para espaços confinados",
      "Altura de elevação até 6.500mm",
      "Alta manobrabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "1.300 - 2.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.500 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Li-Ion",
      "Rodas": "3 rodas"
    },
    description: "Empilhadeira elétrica verde HANGCHA XC Series 3-Wheel - design compacto de 3 rodas para máxima manobrabilidade em espaços reduzidos."
  },
  {
    id: 122,
    name: "A Series Li-Ion 1.3-2.0t",
    model: "CPD13-20-A",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "HANGCHA",
    capacity: "1.3 a 2.0 toneladas",
    image: "https://pt.hangchabrasil.com/upload/images/fd39006b6d15d89e6cc202ca885a31a4.jpg",
    imageIsolated: "https://pt.hangchabrasil.com/upload/images/fd39006b6d15d89e6cc202ca885a31a4.jpg",
    productUrl: "https://pt.hangchabrasil.com/product/detail/A_series_1.3-2.0t(Li-Ion)",
    features: [
      "Modelo compacto da Série A",
      "Bateria de lítio",
      "Altura de elevação até 6.500mm",
      "Ideal para operações leves",
      "Zero emissões",
      "Baixo custo operacional"
    ],
    specifications: {
      "Capacidade de Carga": "1.300 - 2.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "até 6.500 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Li-Ion",
      "Tipo": "Compacta"
    },
    description: "Empilhadeira elétrica verde HANGCHA A Series 1.3-2.0t - modelo compacto com bateria de lítio para operações de pequeno porte."
  },
];

// ===== MAXIMAL PRODUCTS - Imagens oficiais de maxforklift.com =====
export const maximalProducts = [
  // DIESEL - M Series
  {
    id: 201,
    name: "M Series Diesel 1.5-1.8t",
    model: "FD15-18M",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "1.5 a 1.8 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734675588629655.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734675588629655.png",
    features: [
      "Motor diesel compacto",
      "Ideal para espaços reduzidos",
      "Baixo consumo",
      "Fácil manutenção",
      "Design ergonômico",
      "Alta durabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 1.800 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Diesel",
      "Potência": "35 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel MAXIMAL M Series compacta, ideal para operações de pequeno e médio porte."
  },
  {
    id: 202,
    name: "M Series Diesel 2.5-4t",
    model: "FD25-40M",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "2.5 a 4.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734676614545121.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734676614545121.png",
    features: [
      "Motor diesel de alta performance",
      "Caixa de câmbio TCM avançada",
      "Design ergonômico",
      "Sistema de absorção de choques",
      "Baixo consumo",
      "Alta durabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 - 4.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Diesel",
      "Potência": "45 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel MAXIMAL M Series versátil, robustez e eficiência para operações industriais."
  },
  {
    id: 203,
    name: "M Series Diesel 4.5-5t",
    model: "FD45-50M",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "4.5 a 5.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734677762877734.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734677762877734.png",
    features: [
      "Alta capacidade de carga",
      "Motor turbo diesel",
      "Estrutura reforçada",
      "Cabine climatizada opcional",
      "Sistema de freios a disco",
      "Estabilidade superior"
    ],
    specifications: {
      "Capacidade de Carga": "4.500 - 5.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Diesel Turbo",
      "Potência": "65 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel MAXIMAL M Series para cargas pesadas com máxima estabilidade."
  },
  {
    id: 204,
    name: "M Series Diesel 5-7t",
    model: "FD50-70M",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "5.0 a 7.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734678097443303.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734678097443303.png",
    features: [
      "Capacidade industrial",
      "Robustez incomparável",
      "Sistema hidráulico avançado",
      "Cabine confortável",
      "Controles intuitivos",
      "Alta durabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "5.000 - 7.000 kg",
      "Centro de Carga": "600 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Diesel Turbo",
      "Potência": "75 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel MAXIMAL M Series para operações de grande porte."
  },
  // A Series Diesel
  {
    id: 205,
    name: "A Series Diesel 2.5-3.5t",
    model: "FD25-35A",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "2.5 a 3.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734933192503951.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734933192503951.png",
    features: [
      "Design moderno A Series",
      "Motor diesel eficiente",
      "Cabine ergonômica",
      "Baixo consumo",
      "Alta produtividade",
      "Manutenção facilitada"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Diesel",
      "Potência": "45 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira diesel MAXIMAL A Series, design moderno e alta eficiência."
  },
  // Big Truck
  {
    id: 206,
    name: "Big Truck 8-12t",
    model: "FD80-120",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "8 a 12 toneladas",
    image: "https://www.maxforklift.com/upload/product/1736907377285492.jpg",
    imageIsolated: "https://www.maxforklift.com/upload/product/1736907377285492.jpg",
    features: [
      "Capacidade extrema",
      "Motor diesel industrial",
      "Estrutura super reforçada",
      "Sistema hidráulico de alta potência",
      "Cabine panorâmica",
      "Segurança máxima"
    ],
    specifications: {
      "Capacidade de Carga": "8.000 - 12.000 kg",
      "Centro de Carga": "600 mm",
      "Altura de Elevação": "3.000 - 4.500 mm",
      "Motor": "Diesel Industrial",
      "Potência": "120 kW",
      "Transmissão": "Automática"
    },
    description: "Big Truck MAXIMAL para operações de grande porte e cargas superpesadas."
  },
  // Rough Terrain
  {
    id: 207,
    name: "Rough Terrain 4WD 1.8-3.5t",
    model: "RT18-35",
    category: "empilhadeiras",
    fuelType: "diesel",
    brand: "MAXIMAL",
    capacity: "1.8 a 3.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1728976400926508.jpg",
    imageIsolated: "https://www.maxforklift.com/upload/product/1728976400926508.jpg",
    features: [
      "4x4 tração integral",
      "Pneus off-road",
      "Chassi elevado",
      "Ideal para terrenos irregulares",
      "Alta estabilidade",
      "Motor diesel potente"
    ],
    specifications: {
      "Capacidade de Carga": "1.800 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 - 4.500 mm",
      "Motor": "Diesel 4x4",
      "Potência": "55 kW",
      "Tração": "Integral"
    },
    description: "Empilhadeira fora de estrada MAXIMAL 4WD, ideal para construção civil e terrenos acidentados."
  },
  // GLP
  {
    id: 208,
    name: "M Series GLP 1.5-1.8t",
    model: "FGL15-18M",
    category: "empilhadeiras",
    fuelType: "glp",
    brand: "MAXIMAL",
    capacity: "1.5 a 1.8 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734944339351857.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734944339351857.png",
    features: [
      "Motor GLP eficiente",
      "Menor poluição",
      "Uso interno e externo",
      "Economia de combustível",
      "Partida rápida",
      "Manutenção simples"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 1.800 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "GLP",
      "Potência": "35 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira GLP MAXIMAL M Series compacta, versatilidade e economia."
  },
  {
    id: 209,
    name: "M Series GLP 2.5-3.5t",
    model: "FGL25-35M",
    category: "empilhadeiras",
    fuelType: "glp",
    brand: "MAXIMAL",
    capacity: "2.5 a 3.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1734944358991244.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1734944358991244.png",
    features: [
      "Motor GLP potente",
      "Emissões reduzidas",
      "Ideal para indústrias alimentícias",
      "Baixo ruído",
      "Economia operacional",
      "Versatilidade"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "GLP",
      "Potência": "42 kW",
      "Transmissão": "Automática"
    },
    description: "Empilhadeira GLP MAXIMAL M Series para cargas médias com baixa emissão."
  },
  // ELÉTRICAS - Lítio
  {
    id: 210,
    name: "AA Series Lítio 1.5-3.5t",
    model: "FB15-35AA-LI",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "1.5 a 3.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735026153686316.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735026153686316.png",
    features: [
      "Bateria de lítio de alta capacidade",
      "Carga rápida",
      "Zero emissões",
      "Operação silenciosa",
      "Baixo custo operacional",
      "Longa vida útil"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Lítio 80V",
      "Tempo de Carga": "1.5 horas"
    },
    description: "Empilhadeira elétrica MAXIMAL AA Series com tecnologia de bateria de lítio."
  },
  {
    id: 211,
    name: "AX Series Lítio 2.5-3.5t",
    model: "FB25-35AX-LI",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "2.5 a 3.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735022329579235.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735022329579235.png",
    features: [
      "Série AX premium",
      "Bateria de lítio avançada",
      "Alta eficiência",
      "Design moderno",
      "Tecnologia de ponta",
      "Máxima produtividade"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 - 3.500 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Lítio 80V",
      "Tempo de Carga": "1.5 horas"
    },
    description: "Empilhadeira elétrica MAXIMAL AX Series premium com bateria de lítio."
  },
  {
    id: 212,
    name: "AX Series Lítio 4.5-5t",
    model: "FB45-50AX-LI",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "4.5 a 5.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735027847990526.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735027847990526.png",
    features: [
      "Alta capacidade elétrica",
      "Bateria de lítio industrial",
      "Zero emissões",
      "Operação silenciosa",
      "Economia operacional",
      "Robustez"
    ],
    specifications: {
      "Capacidade de Carga": "4.500 - 5.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Elétrico AC",
      "Bateria": "Lítio 96V",
      "Tempo de Carga": "2 horas"
    },
    description: "Empilhadeira elétrica MAXIMAL AX Series para cargas pesadas com lítio."
  },
  {
    id: 214,
    name: "AX Series Lítio 5-7t",
    model: "FB50-70AX-LI",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "5.0 a 7.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735030453299456.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735030453299456.png",
    features: [
      "Alta capacidade elétrica",
      "Bateria de lítio de alta potência",
      "Zero emissões",
      "Operação silenciosa",
      "Ideal para operações médias-pesadas",
      "Tecnologia avançada"
    ],
    specifications: {
      "Capacidade de Carga": "5.000 - 7.000 kg",
      "Centro de Carga": "500 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Elétrico AC Industrial",
      "Bateria": "Lítio 96V",
      "Tempo de Carga": "2 horas"
    },
    description: "Empilhadeira elétrica MAXIMAL AX Series 5-7t com bateria de lítio para cargas pesadas."
  },
  {
    id: 213,
    name: "AX Series Lítio 8-10t",
    model: "FB80-100AX-LI",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "8.0 a 10.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1770359637653662.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1770359637653662.png",
    features: [
      "Capacidade industrial máxima",
      "Bateria de lítio de alta potência",
      "Zero emissões",
      "Operação silenciosa",
      "Ideal para grandes operações",
      "Tecnologia avançada"
    ],
    specifications: {
      "Capacidade de Carga": "8.000 - 10.000 kg",
      "Centro de Carga": "600 mm",
      "Altura de Elevação": "3.000 mm",
      "Motor": "Elétrico AC Industrial",
      "Bateria": "Lítio 120V",
      "Tempo de Carga": "2.5 horas"
    },
    description: "Empilhadeira elétrica MAXIMAL AX Series de alta capacidade com lítio - lançamento 2025."
  },
  // ===== PALLET STACKERS =====
  {
    id: 215,
    name: "Pallet Stacker PS12-A2SL / PS15-A2SL",
    model: "PS12-A2SL / PS15-A2SL / PS15-A2SLK",
    category: "stackers",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "1.2 a 1.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735098365369231.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735098365369231.png",
    features: [
      "Bateria de lítio de alta eficiência",
      "Design compacto para corredores estreitos",
      "Elevação até 2.500mm",
      "Operação ergonômica",
      "Baixo custo de manutenção",
      "Alta produtividade"
    ],
    specifications: {
      "Capacidade de Carga": "1.200 - 1.500 kg",
      "Altura de Elevação": "2.500 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Tipo": "Pallet Stacker com plataforma"
    },
    description: "Pallet Stacker MAXIMAL PS12/PS15 A2SL com bateria de lítio - ideal para empilhamento em armazéns."
  },
  {
    id: 216,
    name: "Pallet Stacker PS15-M2X / PS15-MXK",
    model: "PS15-M2X / PS15-MXK",
    category: "stackers",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "1.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735634744495397.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735634744495397.png",
    features: [
      "Bateria de lítio",
      "Elevação até 1.300mm",
      "Design compacto",
      "Operação silenciosa",
      "Fácil manutenção",
      "Alta manobrabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 kg",
      "Altura de Elevação": "1.300 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Tipo": "Pallet Stacker compacto"
    },
    description: "Pallet Stacker MAXIMAL PS15-M2X com bateria de lítio - compacto e eficiente."
  },
  {
    id: 217,
    name: "Pallet Stacker PS15-MRX / PS15-MRXK",
    model: "PS15-MRX / PS15-MRXK",
    category: "stackers",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "1.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735115265232481.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735115265232481.png",
    features: [
      "Bateria de lítio",
      "Design tipo rider (operador embarcado)",
      "Alta velocidade de operação",
      "Ergonômico",
      "Ideal para longas distâncias",
      "Baixo consumo de energia"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 kg",
      "Altura de Elevação": "120 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Tipo": "Pallet Stacker Rider"
    },
    description: "Pallet Stacker MAXIMAL PS15-MRX tipo Rider com bateria de lítio - operador embarcado para maior produtividade."
  },
  // ===== PALLET TRUCKS (PALETEIRAS) =====
  {
    id: 218,
    name: "Pallet Truck PT20-M2SL",
    model: "PT20-M2SL",
    category: "paleteiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "2.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735117063245284.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735117063245284.png",
    features: [
      "Bateria de lítio de alta capacidade",
      "Operação acompanhada",
      "Altura de elevação 115mm",
      "Design ergonômico",
      "Frenagem regenerativa",
      "Baixo ruído"
    ],
    specifications: {
      "Capacidade de Carga": "2.000 kg",
      "Altura do Garfo": "115 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Velocidade": "6 km/h"
    },
    description: "Paleteira elétrica MAXIMAL PT20-M2SL com bateria de lítio - agilidade para movimentação horizontal."
  },
  {
    id: 219,
    name: "Pallet Truck PT15,20-M1L",
    model: "PT15-M1L / PT20-M1L",
    category: "paleteiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "1.5 a 2.0 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735117305355216.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735117305355216.png",
    features: [
      "Bateria de lítio",
      "Modelos 1.5t e 2.0t",
      "Altura de elevação 115mm",
      "Compacta e ágil",
      "Operação intuitiva",
      "Alta manobrabilidade"
    ],
    specifications: {
      "Capacidade de Carga": "1.500 - 2.000 kg",
      "Altura do Garfo": "115 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Velocidade": "5-6 km/h"
    },
    description: "Paleteira elétrica MAXIMAL PT15/PT20-M1L com bateria de lítio - versátil para diversas aplicações."
  },
  {
    id: 220,
    name: "Pallet Truck PT16,20,25-M",
    model: "PT16-M / PT20-M / PT25-M",
    category: "paleteiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "1.6 a 2.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735173798378114.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735173798378114.png",
    features: [
      "Bateria de lítio",
      "Linha completa 1.6t, 2.0t e 2.5t",
      "Altura de elevação 120mm",
      "Alta capacidade de carga",
      "Robusto e durável",
      "Ideal para uso intensivo"
    ],
    specifications: {
      "Capacidade de Carga": "1.600 - 2.500 kg",
      "Altura do Garfo": "120 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Velocidade": "5-6 km/h"
    },
    description: "Paleteira elétrica MAXIMAL série M com bateria de lítio - linha completa para diferentes capacidades."
  },
  {
    id: 221,
    name: "Pallet Truck Rider PT20,25-MR",
    model: "PT20-MR / PT25-MR",
    category: "paleteiras",
    fuelType: "eletrica",
    brand: "MAXIMAL",
    capacity: "2.0 a 2.5 toneladas",
    image: "https://www.maxforklift.com/upload/product/1735172326104715.png",
    imageIsolated: "https://www.maxforklift.com/upload/product/1735172326104715.png",
    features: [
      "Bateria de lítio",
      "Operador embarcado (Rider)",
      "Altura de elevação 120mm",
      "Ideal para longas distâncias",
      "Alta produtividade",
      "Conforto do operador"
    ],
    specifications: {
      "Capacidade de Carga": "2.000 - 2.500 kg",
      "Altura do Garfo": "120 mm",
      "Motor": "Elétrico",
      "Bateria": "Lítio",
      "Velocidade": "8 km/h",
      "Tipo": "Rider (operador embarcado)"
    },
    description: "Paleteira elétrica MAXIMAL PT20/PT25-MR tipo Rider com bateria de lítio - operador embarcado para maior velocidade e conforto."
  }
];

// ===== PALETRANS PRODUCTS - Imagens oficiais de paletrans.com.br =====
export const paletransProducts = [
  {
    id: 301,
    name: "Empilhadeira Elétrica PT 1625",
    model: "PT1625",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "PALETRANS",
    capacity: "1.6 toneladas - 2.5m",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0002_Empilhadeira-Eletrica-Patolada-PT1625_005-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0002_Empilhadeira-Eletrica-Patolada-PT1625_005-300x300.jpg",
    features: [
      "Empilhadeira elétrica patolada",
      "Estrutura robusta nacional",
      "Ideal para pequenas operações",
      "Baixo custo de manutenção",
      "Compacta",
      "Fácil utilização"
    ],
    specifications: {
      "Capacidade de Carga": "1.600 kg",
      "Altura de Elevação": "2.500 mm",
      "Tipo": "Elétrica Patolada",
      "Fabricação": "Nacional"
    },
    description: "Empilhadeira PALETRANS PT1625, solução nacional para operações de empilhamento até 2.5m."
  },
  {
    id: 302,
    name: "Empilhadeira Elétrica PT 1635",
    model: "PT1635",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "PALETRANS",
    capacity: "1.6 toneladas - 3.5m",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0002_Empilhadeira-Eletrica-Patolada-PT1635_005-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0002_Empilhadeira-Eletrica-Patolada-PT1635_005-300x300.jpg",
    features: [
      "Maior altura de elevação",
      "Estrutura reforçada",
      "Empilhadeira elétrica",
      "Versatilidade",
      "Baixo investimento",
      "Durabilidade nacional"
    ],
    specifications: {
      "Capacidade de Carga": "1.600 kg",
      "Altura de Elevação": "3.500 mm",
      "Tipo": "Elétrica Patolada",
      "Fabricação": "Nacional"
    },
    description: "Empilhadeira PALETRANS PT1635 com elevação até 3.5 metros."
  },
  {
    id: 303,
    name: "Empilhadeira Elétrica PT 1645",
    model: "PT1645",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "PALETRANS",
    capacity: "1.6 toneladas - 4.5m",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0003_Empilhadeira-Eletrica-Patolada-PT1635_005-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0003_Empilhadeira-Eletrica-Patolada-PT1635_005-300x300.jpg",
    features: [
      "Máxima altura da linha PT",
      "Estrutura super reforçada",
      "Operação segura",
      "Alta produtividade",
      "Custo-benefício",
      "Manutenção simples"
    ],
    specifications: {
      "Capacidade de Carga": "1.600 kg",
      "Altura de Elevação": "4.500 mm",
      "Tipo": "Elétrica Patolada",
      "Fabricação": "Nacional"
    },
    description: "Empilhadeira PALETRANS PT1645 para elevação até 4.5 metros."
  },
  {
    id: 304,
    name: "Empilhadeira Retrátil PR 2010,5i",
    model: "PR2010,5i",
    category: "retrateis",
    fuelType: "eletrica",
    brand: "PALETRANS",
    capacity: "2.0 toneladas - 10.5m",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0017_Empilhadeira-Retratil-PR20i_008-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0017_Empilhadeira-Retratil-PR20i_008-300x300.jpg",
    features: [
      "Mastro retrátil",
      "Alta elevação até 10.5m",
      "Corredores estreitos",
      "Bateria de alta duração",
      "Operação ergonômica",
      "Tecnologia nacional"
    ],
    specifications: {
      "Capacidade de Carga": "2.000 kg",
      "Altura de Elevação": "10.500 mm",
      "Motor": "Elétrico AC",
      "Bateria": "48V",
      "Largura do Corredor": "2.800 mm"
    },
    description: "Empilhadeira retrátil PALETRANS PR2010,5i para armazéns de alta verticalização."
  },
  {
    id: 305,
    name: "Transpaleteiro Manual TM 2500",
    model: "TM2500",
    category: "transpaletes",
    fuelType: "manual",
    brand: "PALETRANS",
    capacity: "2.5 toneladas",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0005_Transpalete-Manual-TM2500-Roda-Tandem-Poliuretano_001-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0005_Transpalete-Manual-TM2500-Roda-Tandem-Poliuretano_001-300x300.jpg",
    features: [
      "Operação 100% manual",
      "Estrutura em aço reforçado",
      "Sistema hidráulico selado",
      "Rodas tandem poliuretano",
      "Baixa manutenção",
      "Fabricação nacional"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 kg",
      "Altura Mínima do Garfo": "85 mm",
      "Altura Máxima do Garfo": "200 mm",
      "Comprimento do Garfo": "1.150 mm",
      "Rodas": "Tandem Poliuretano",
      "Peso": "75 kg"
    },
    description: "Transpaleteiro manual PALETRANS TM2500, resistência e economia - fabricado no Brasil."
  },
  {
    id: 306,
    name: "Transpaleteiro Manual TM 2500 RTN",
    model: "TM2500-RTN",
    category: "transpaletes",
    fuelType: "manual",
    brand: "PALETRANS",
    capacity: "2.5 toneladas",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0006_Transpalete-Manual-TM2500-Roda-Tandem-Nylon_001-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0006_Transpalete-Manual-TM2500-Roda-Tandem-Nylon_001-300x300.jpg",
    features: [
      "Rodas tandem nylon",
      "Estrutura reforçada",
      "Sistema hidráulico selado",
      "Ideal para pisos lisos",
      "Alta durabilidade",
      "Fabricação nacional"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 kg",
      "Altura Mínima do Garfo": "85 mm",
      "Altura Máxima do Garfo": "200 mm",
      "Comprimento do Garfo": "1.150 mm",
      "Rodas": "Tandem Nylon",
      "Peso": "75 kg"
    },
    description: "Transpaleteiro manual PALETRANS TM2500 com rodas de nylon."
  },
  {
    id: 307,
    name: "Empilhadeira Contrabalançada PC25",
    model: "PC25",
    category: "empilhadeiras",
    fuelType: "eletrica",
    brand: "PALETRANS",
    capacity: "2.5 toneladas",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/0005_Empilhadeira-Contrabalancada-PC25_009-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/0005_Empilhadeira-Contrabalancada-PC25_009-300x300.jpg",
    features: [
      "LANÇAMENTO 2025",
      "Bateria de lítio recarga rápida",
      "Alto desempenho",
      "Eficiência energética",
      "Motores potentes",
      "Menor custo operacional"
    ],
    specifications: {
      "Capacidade de Carga": "2.500 kg",
      "Tipo": "Contrabalançada Elétrica",
      "Bateria": "Lítio",
      "Motor": "Elétrico de Alta Potência",
      "Fabricação": "Nacional"
    },
    description: "NOVO PC25 PALETRANS - Empilhadeira contrabalançada elétrica de alto desempenho com bateria de lítio - Lançamento do Ano!"
  },
  {
    id: 308,
    name: "Transpalete Elétrico TE21",
    model: "TE21",
    category: "transpaletes",
    fuelType: "eletrica",
    brand: "PALETRANS",
    capacity: "2.1 toneladas",
    image: "https://paletrans.com.br/wp-content/uploads/2025/09/TE21-300x300.jpg",
    imageIsolated: "https://paletrans.com.br/wp-content/uploads/2025/09/TE21-300x300.jpg",
    features: [
      "LANÇAMENTO 2025",
      "Compacto com performance de gigante",
      "Maior capacidade do mercado",
      "3x mais autonomia",
      "Forte e resistente",
      "Fácil manutenção"
    ],
    specifications: {
      "Capacidade de Carga": "2.100 kg",
      "Tipo": "Transpalete Elétrico",
      "Motor": "Elétrico",
      "Fabricação": "Nacional"
    },
    description: "NOVO TE21 PALETRANS - Transpalete elétrico compacto com a maior capacidade de carga do mercado e 3x mais autonomia!"
  }
];

// Combined products array
export const products = [
  ...hangchaProducts,
  ...maximalProducts,
  ...paletransProducts
];

export const accessories = [
  {
    id: 1,
    name: "Deslocador Lateral",
    category: "acessorios",
    capacity: "1 a 10 toneladas",
    model: "Class 2A, 3A, 4A",
    quality: "CE, ISO, 3C",
    weight: "60kg a 300kg",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/08d1230e8f886feebb61c3934309838a141e165b77498bb4472e6d72b9591ac3.png",
    description: "Permite o deslocamento lateral da carga para posicionamento preciso. Movimento de ±100mm a ±150mm sem reposicionar a empilhadeira."
  },
  {
    id: 2,
    name: "Posicionador de Garfos",
    category: "acessorios",
    capacity: "1 a 10 toneladas",
    model: "Class 2A, 3A, 4A",
    quality: "CE, ISO, first class",
    weight: "100kg a 400kg",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/8259bf75d127d15b10815bd9402f85076e6d780421f00701d9305db109bdf10f.png",
    description: "Ajuste hidráulico da distância entre os garfos diretamente do assento do operador. Aumenta produtividade e reduz danos às cargas."
  },
  {
    id: 3,
    name: "Garra para Papel / Paper Roll Clamp",
    category: "acessorios",
    capacity: "1.5 a 3 toneladas",
    model: "Class II, III",
    quality: "Top quality",
    weight: "600kg",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/94d5034475d6e72549d9f2c91825c02a5ef19debd792c815d0b4b8e2dab6c58c.png",
    description: "Ideal para manuseio de rolos e bobinas de papel. Braços curvos com almofadas de borracha para pegar sem danificar."
  },
  {
    id: 4,
    name: "Garra Bobina de Papel",
    category: "acessorios",
    capacity: "2 a 2.5 toneladas",
    model: "Class II, III",
    quality: "CE, ISO, 3C",
    weight: "680kg a 1100kg",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/94d5034475d6e72549d9f2c91825c02a5ef19debd792c815d0b4b8e2dab6c58c.png",
    description: "Projetada para bobinas de grande porte em fábricas de papel e centros de distribuição."
  },
  {
    id: 5,
    name: "Garfo Giratório / Rotator",
    category: "acessorios",
    capacity: "1 a 5 toneladas",
    model: "Custom",
    quality: "CE, ISO",
    weight: "Variável",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/be625077824f099b536e2ba177a1dadbd57511e5bd651ea1a5cacac34e9918bb.png",
    description: "Rotação 360° para posicionamento preciso de cargas. Motor hidráulico Eaton de alta durabilidade."
  },
  {
    id: 6,
    name: "Garfos Duplos",
    category: "acessorios",
    capacity: "Variável",
    model: "Custom",
    quality: "CE, ISO",
    weight: "Variável",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/98777f86e50abf638d08fe7a36b37fdacc24585ca9aadb4457c5847378face2f.png",
    description: "Dobra a capacidade de movimentação por viagem. Ideal para operações de alto volume."
  }
];

export const tires = [
  {
    id: 1,
    name: "Pneu com Câmara",
    type: "com-camara",
    description: "Pneus pneumáticos com câmara para empilhadeiras. Ideal para operações externas e pisos irregulares.",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/d6720e83adc4682b5848720379194f47f497587bcf319c8685c4bdd6b4b16e59.png",
    features: ["Maior absorção de impactos", "Ideal para pisos irregulares", "Custo acessível", "Boa tração em superfícies molhadas"]
  },
  {
    id: 2,
    name: "Pneu Maciço",
    type: "macico",
    description: "Pneus maciços de alta durabilidade. Perfeitos para uso intensivo em ambientes industriais.",
    image: "https://static.prod-images.emergentagent.com/jobs/5fe5c2d4-f24d-4e91-bfb4-90d78e6159a4/images/8497bd31812d693b22ec57edda3a4da0d81ef58f1729aad6431d5d303fe2f5c8.png",
    features: ["Sem risco de furos", "Maior durabilidade", "Ideal para uso intensivo", "Menor manutenção", "Estabilidade superior"]
  }
];

export const rentalBenefits = [
  {
    id: 1,
    title: "Isenção Fiscal",
    description: "100% dedutível do Imposto de Renda.",
    icon: "Receipt"
  },
  {
    id: 2,
    title: "Capital Zero",
    description: "Não requer investimento inicial ou capital parado.",
    icon: "PiggyBank"
  },
  {
    id: 3,
    title: "Manutenção Inclusa",
    description: "Preventiva, corretiva, peças e mão de obra por nossa conta.",
    icon: "Wrench"
  },
  {
    id: 4,
    title: "Sem Obsolescência",
    description: "Elimina perdas com equipamentos ultrapassados.",
    icon: "RefreshCw"
  },
  {
    id: 5,
    title: "Garantia Total",
    description: "Substituição ou reparo em até 48h após aviso.",
    icon: "ShieldCheck"
  },
  {
    id: 6,
    title: "Custo Definido",
    description: "Custos conhecidos, definidos e faturados mensalmente.",
    icon: "Calculator"
  }
];

export const differentials = [
  {
    id: 1,
    title: "25 Anos de Experiência",
    description: "Desde 2000 atuando no mercado de empilhadeiras com excelência.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Importação Direta",
    description: "Importamos diretamente da fábrica, garantindo os melhores preços.",
    icon: "Ship"
  },
  {
    id: 3,
    title: "Atendimento Personalizado",
    description: "Soluções individualizadas para cada necessidade do cliente.",
    icon: "HeadphonesIcon"
  },
  {
    id: 4,
    title: "Frota Diversificada",
    description: "Empilhadeiras de 1 a 35 toneladas em diversos modelos.",
    icon: "Truck"
  },
  {
    id: 5,
    title: "Suporte Técnico",
    description: "Equipe especializada para manutenção e suporte.",
    icon: "HeartHandshake"
  },
  {
    id: 6,
    title: "Qualidade Certificada",
    description: "Produtos com certificação CE, ISO e padrões internacionais.",
    icon: "BadgeCheck"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    company: "Logística Express",
    text: "A Paulare é nossa parceira há mais de 10 anos. Sempre entregam equipamentos de qualidade e o suporte é excepcional.",
    rating: 5
  },
  {
    id: 2,
    name: "Maria Santos",
    company: "Distribuidora Norte",
    text: "O serviço de locação nos ajudou a expandir sem grandes investimentos. Recomendo fortemente!",
    rating: 5
  },
  {
    id: 3,
    name: "Roberto Oliveira",
    company: "Indústria Metalmax",
    text: "Profissionalismo e qualidade definem a Paulare. Nossa operação melhorou muito com os equipamentos deles.",
    rating: 5
  }
];

// Hero images for different sections - Updated with carousel images
export const heroImages = {
  home: [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_d9364d8b-3c3d-467f-aed0-dabbca109e0d/artifacts/dy3oo3cg_sky.jpg",
      alt: "Fachada Paulare Empilhadeiras",
      title: "fachada"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_d9364d8b-3c3d-467f-aed0-dabbca109e0d/artifacts/hy6f4h3m_ChatGPT%20Image%2018%20de%20mar.%20de%202026%2C%2019_40_49.png",
      alt: "Empilhadeira verde em operação no armazém",
      title: "empilhadeira"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_d9364d8b-3c3d-467f-aed0-dabbca109e0d/artifacts/vdb2etht_ChatGPT%20Image%2018%20de%20mar.%20de%202026%2C%2019_40_46.png",
      alt: "Frota de empilhadeiras verdes",
      title: "frota"
    }
  ],
  products: "https://pt.hangchabrasil.com/upload/images/bfde389273840fad8597f2baaae40e89.jpg",
  rental: "https://paletrans.com.br/wp-content/uploads/2025/05/BANNER-PRODUTO-DESTAQUEPC25.jpg",
  company: "https://customer-assets.emergentagent.com/job_d9364d8b-3c3d-467f-aed0-dabbca109e0d/artifacts/zpzf7klj_sky.jpg"
};
